/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_change_username_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3-16 characters. Letters, numbers, and underscore only. Usernames are unique case-insensitively.`)
};

const zh_hans1_settings_change_username_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3-16 个字符。只能包含字母、数字和下划线。用户名不区分大小写且唯一。`)
};

const zh_hant1_settings_change_username_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3–16 個字元。只能包含英文字母、數字與底線。使用者名稱不區分大小寫且必須唯一。`)
};

const fr_settings_change_username_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 à 16 caractères. Lettres, chiffres et underscore uniquement. Les noms d’utilisateur sont uniques sans tenir compte de la casse.`)
};

const de_settings_change_username_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3–16 Zeichen. Nur Buchstaben, Zahlen und Unterstrich. Benutzernamen sind ohne Beachtung der Groß-/Kleinschreibung eindeutig.`)
};

const ja_settings_change_username_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3〜16 文字。英数字とアンダースコアのみ。ユーザー名は大文字小文字を区別せず一意です。`)
};

const ko_settings_change_username_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3~16자. 문자, 숫자, 밑줄(_)만 사용 가능합니다. 사용자 이름은 대소문자 구분 없이 유일합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_change_username_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_change_username_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_change_username_desc", locale)
	if (locale === "en") return en_settings_change_username_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_change_username_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_change_username_desc(inputs)
	if (locale === "fr") return fr_settings_change_username_desc(inputs)
	if (locale === "de") return de_settings_change_username_desc(inputs)
	if (locale === "ja") return ja_settings_change_username_desc(inputs)
	return ko_settings_change_username_desc(inputs)
};